import React from 'react';

import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';


function DocumentState({ etat, facultatif  }) {
  switch (etat) {
    case 'manquant':
      return (
        <>
          <div className='col-span-4 w-full flex items-center justify-end gap-4 text-red-600 font-medium'>
            <div className='inline-block'>Manquant {facultatif && <span className='italic'> (Facultatif)</span>}</div>
            <div className='inline-block'><CloseIcon /></div>
          </div>
        </>
      )
    case 'attente':
      return (
        <>
          <div className='col-span-4 w-full flex items-center justify-end gap-4 text-orange-400 font-medium'>
            <div className='inline-block'>Déposé</div>
            <div className='inline-block'><MoreHorizIcon /></div>
          </div>
        </>
      )
    case 'valide':
      return (
        <>
          <div className='col-span-4 w-full flex items-center justify-end gap-4 text-green-600 font-medium'>
            <div className='inline-block'>Validé</div>
            <div className='inline-block'><CheckIcon /></div>
          </div>
        </>
      )
    case 'rejet':
      return (
        <>
          <div className='col-span-4 w-full flex items-center justify-end gap-4 text-red-600 font-medium'>
            <div className='inline-block'>Rejeté</div>
            <div className='inline-block'><CloseIcon /></div>
          </div>
        </>
      )
  }
};

export default DocumentState;